/** Only report errors thrown from scripts we serve. */
export const ALLOW_URLS = [/staging.locallogic.co/, /sdk.locallogic.co/];
